import * as React from "react";
import BookChip from "../../../../BookCalendar/BooksSidebar/BookChip/BookChip";
import { LibraryCard, CardType } from "../../../../../types/LibraryCard";
import { Month } from "../../../Calendar";
import { CardWithDate } from "../../../../../store/calendar/selectors";
import { localedFormat, getDatePeriod } from "../../../../../utils";
import { isFuture, isPast } from "date-fns";
import './MonthModal.css';

interface Props {
	month: Month;
	setSelectedCard: (card: LibraryCard) => void;
}

interface BooksType {
	readNow: CardWithDate[];
	readed: CardWithDate[];
	wantRead: CardWithDate[];
}

const MonthModal: React.FC<Props> = ({ month, setSelectedCard }) => {
	const books: BooksType = React.useMemo(() => {
		const tmp: BooksType = {
			readNow: [],
			readed: [],
			wantRead: [],
		};

		const books = month.cards.sort((a, b) => {
			return b.startDate.getTime() - a.startDate.getTime();
		});

		books.forEach((card) => {
			switch (card.type) {
				case CardType.ReadNow:
					tmp.readNow.push(card);
					break;
				case CardType.WantRead:
					tmp.wantRead.push(card);
					break;
				case CardType.AlreadyRead:
					tmp.readed.push(card);
					break;
			}
		});

		return tmp;
	}, [month.cards]);

	const future = React.useMemo(() => {
		return isFuture(month.startOfMonth);
	}, [month.startOfMonth]);

	const past = React.useMemo(() => {
		return isPast(month.startOfMonth);
	}, [month.startOfMonth]);

	return (
		<div className="monthModal">
			<div className="monthModal__month">
				{localedFormat(month.startOfMonth, "LLLL, yyyy")}
			</div>

			{books.readNow.length > 0 && (
				<div>
					<div className="monthModal__header">Читаю сейчас</div>

					<div>
						{books.readNow.map((card) => {
							return (
								<BookChip
									key={card.card.eId}
									card={card.card}
									customPeriod={getDatePeriod(card.startDate, card.endDate, 'c ', ' по ')}
									onClick={() => {
										setSelectedCard(card.card);
									}}
									className="day__book"
								/>
							);
						})}
					</div>
				</div>
			)}

			{books.wantRead.length > 0 && (
				<div>
					<div className="monthModal__header">Запланировано</div>

					<div>
						{books.wantRead.map((card) => {
							return (
								<BookChip
									key={card.card.eId}
									card={card.card}
									customPeriod={getDatePeriod(
										card.startDate,
										card.endDate,
										"c ",
										" по ",
										true
									)}
									onClick={() => {
										setSelectedCard(card.card);
									}}
									className="day__book"
								/>
							);
						})}
					</div>
				</div>
			)}

			{books.readed.length > 0 && (
				<div>
					<div className="monthModal__header">Прочитано</div>

					<div>
						{books.readed.map((card) => {
							return (
								<BookChip
									key={card.card.eId}
									card={card.card}
									customPeriod={getDatePeriod(
										card.startDate,
										card.endDate,
										"c ",
										" по "
									)}
									onClick={() => {
										setSelectedCard(card.card);
									}}
									className="day__book"
								/>
							);
						})}
					</div>
				</div>
			)}

			{books.readed.length === 0 && past && books.readNow.length === 0 && (
				<div className="monthModal__emptyHistory">
					<div className="monthModal__emptyHistory-logo" />В этом месяце нет
					прочитанных книг
				</div>
			)}

			{books.wantRead.length === 0 && future && (
				<div className="monthModal__emptyHistory">
					<div className="monthModal__emptyWants-logo" />
					На этот месяц нет запланированных книг
				</div>
			)}
		</div>
	);
};

export default MonthModal;
